import { EmptyState, buttonClass } from "@gf/ui";
import { Lock } from "lucide-react";
import { Link } from "react-router";

export function Forbidden() {
  return (
    <div className="gfp-center-page">
      <EmptyState
        size="lg"
        icon={<Lock />}
        title="This room is for made men only."
        description="Your account doesn't have access to this page. If you think it should, ask whoever set up your account."
        action={
          <Link to="/" className={buttonClass({ variant: "secondary" })}>
            Back to home
          </Link>
        }
      />
    </div>
  );
}

export function NotFound() {
  return (
    <div className="gfp-center-page">
      <EmptyState
        size="lg"
        icon={<span className="gfp-404">404</span>}
        title="This page sleeps with the fishes."
        description="The link is broken or the page moved. Head back home and pick up where you left off."
        action={
          <Link to="/" className={buttonClass({ variant: "secondary" })}>
            Back to home
          </Link>
        }
      />
    </div>
  );
}
